import {i18n} from '@/plugins/i18n';

const formatDate = (date, time) => {
    let d1 = String(date).slice(0, 4);
    let d2 = String(date).slice(4, 6);
    let d3 = String(date).slice(6, 8);

    let t1 = String(time).slice(0, 2);
    let t2 = String(time).slice(2, 4);
    let t3 = String(time).slice(4, 6);

    return d1 + '/' + d2 + '/' + d3 + ' ' + t1 + ':' + t2 + ':' + t3;
};

const formatAmount = (credit, debit) => {
    credit = Number(credit);
    debit = Number(debit);

    if (credit === 0) {
        return debit;
    }

    return credit;
};

const detectType = (credit) => {
    credit = Number(credit);

    if (credit === 0) {
        return i18n.t('label.account_withdraw');
    }

    return i18n.t('label.account_charge');
};

export default [
    {
        field: 'optionalInformation',
        title: i18n.t('label.track_code'),
        sortable: false,
        type: 'string',
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: false,
        type: 'string',
        template: row => {
            return '<div dir="ltr">' + detectType(row.transactionAmountCredit) + '</div>';
        },
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('label.title'),
        sortable: false,
        type: 'string',
        template: row => {
            return '<div dir="ltr">' + row.operationCode.message + '</div>';
        },
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount'),
        sortable: false,
        type: 'string',
        template: row => {
            return '<div dir="ltr">' + row.amount + '</div>';
        },
        textAlign: 'center',
    },
    {
        field: 'datetime',
        title: i18n.t('label.date'),
        sortable: false,
        type: 'string',
        template: row => {
            return '<div dir="ltr">' + formatDate(row.fullDate, row.time) + '</div>';
        },
        textAlign: 'center',
    },
]
